import { render, staticRenderFns } from "./BetaWarning.vue?vue&type=template&id=3eff31b8"
import script from "./BetaWarning.vue?vue&type=script&lang=js"
export * from "./BetaWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports